import { Button, Container, Stack, Typography } from "@mui/material";
import ReportsTable from "./ReportsTable";
import AddIcon from "@mui/icons-material/Add";
import ReportsCreateDialog from "./ReportsCreateDialog";
import { useEffect, useState } from "react";
import axios from "axios";
import { Report } from "../types/Report";

export default function ReportsPage() {
  const [reports, setReports] = useState<Report[]>();
  const [createDialogOpen, setCreateDialogOpen] = useState(false);

  const fetchReport = () => {
    axios
      .get(`${process.env.REACT_APP_API_HOST}/reports`)
      .then((response) => setReports(response.data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  useEffect(() => {
    fetchReport();

    const refreshInterval = setInterval(fetchReport, 10000);

    return () => clearInterval(refreshInterval);
  }, []);

  return (
    <Container>
      <Stack pt={2} pb={2} alignItems="flex-end">
        <Button
          startIcon={<AddIcon />}
          variant="contained"
          sx={{ width: 230 }}
          onClick={() => setCreateDialogOpen(true)}
          disabled={reports?.some((report) => report.status === "En progreso")}
        >
          Crear Reporte
        </Button>
        <Typography variant="caption" color="textSecondary">
          * Hay un reporte en progreso. Solo se puede crear un reporte a la vez.
        </Typography>
      </Stack>
      <ReportsTable reports={reports} setReports={setReports} />
      <ReportsCreateDialog
        open={createDialogOpen}
        setOpen={setCreateDialogOpen}
        handleFetchReport={fetchReport}
      />
    </Container>
  );
}
